// extracted by mini-css-extract-plugin
export default {"filterLabel":"TransactionHistory_filterLabel__ICxsZ"};